import React, { JSX } from 'react';
import { faInfo } from '@fortawesome/free-solid-svg-icons';
import { Message, MessageClass } from './Message';

export interface Props {
  message: string;
  title?: string;
}

const Info = (props: Props): JSX.Element => {
  const { message, title } = props;
  return <Message message={message} messageClass={MessageClass.INFO} icon={faInfo} title={title} />;
};
export default Info;
